import script from "./DecryptFuckOff.vue?vue&type=script&setup=true&lang=js"
export * from "./DecryptFuckOff.vue?vue&type=script&setup=true&lang=js"

import "./DecryptFuckOff.vue?vue&type=style&index=0&id=6fb8af5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb8af5c"]])

export default __exports__